var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pa-5 deskripsi"},[(_vm.items.desc !=null)?_c('div',[_vm._v(_vm._s(_vm.items.desc))]):_vm._e(),(_vm.items.desc == null)?_c('div',[_vm._v("Tidak ada deskripsi")]):_vm._e()]),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }